import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/LoginMenu'
import PaybankContent from '../pages/paybankContent'
import Toppart from '../pages/toppart'
import Footer from '../pages/Footer'

export default function Payday() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<PaybankContent />
			<Footer />	
		</div>	
	)
}
			